module.exports = __webpack_public_path__ + "static/media/barcodeImage_qr.4d854fe4.svg";